module.exports = __webpack_public_path__ + "img/answer.292f5a8d.png";